<template>
    <div class="versioninfo">
        <el-card class="box-card">
            <div class="box-card-a">
                <div class="version-web">web端版本号:1.4.0316_bate</div>
            </div>
            <div></div>
        </el-card>
    </div>
</template>
<script>
export default {
}
</script>
<style lang="scss" scoped>
    .versioninfo{
        padding-bottom:10px;
        margin:0.5% 0%;
        width:100%;
        min-height:400px;
        border:1px solid #ccc;
        .box-card{
            margin: 2% auto;
            width:98%;
            min-height:400px;
            display: flex;
            justify-content: center;
            align-items: center;
            .box-card-a{
                width:400px;
                height:200px;
                .version-web{
                    height:40px;
                    line-height:40px;
                    font-size: 16px;
                }
                .version-java{
                    font-size: 16px;
                }
            }
        }
    }
</style>